export default __webpack_public_path__ + "static/media/servicios_2.4bc76c74.jpg";